<template>
    <div class="w-full flex-grow bg-gray-100 flex flex-col rounded-lg p-4">
        <div class="flex justify-between items-center mb-4">
            <div class="select_mode">
                <div class="">
                    <VDropdown
                        placement="bottom-start"
                        auto-boundary-max-size
                        :prevent-overflow="true"
                        :overflow-padding="10"
                    >
                        <span class="cursor-pointer text-sm">Reply </span>
                        <fa :icon="['fas', 'chevron-down']" class="text-[10px] leading-normal text-black-600" />
                        <template #popper="{ hide }">
                            <ul class="p-4">
                                <li
                                    class="text-dark-100 italic text-sm flex p-2 rounded-lg items-center cursor-pointer hover:bg-gray-100"
                                    @click="(openNoteMethod(), hide())"
                                >
                                    <fa :icon="['fal', 'note']" class="text-gray-navtext mr-1 text-lg" />
                                    Add note
                                </li>
                            </ul>
                        </template>
                    </VDropdown>
                </div>
            </div>
            <fa
                :icon="['fal', 'arrow-up-right-and-arrow-down-left-from-center']"
                class="!text-sm !text-gray-300cursor-pointer"
                @click="null"
            />
        </div>
        <div class="message_area flex w-full flex-grow">
            <FormKit
                :model-value="input"
                type="textarea"
                :disabled="isLoading"
                name="instructions"
                placeholder="Enter message here..."
                outer-class="!mb-0 flex-grow"
                wrapper-class="!max-w-full"
                inner-class="!outline-none !border-none !p-0 !bg-gray-100 text-sm leading-[17px]"
                input-class="!bg-gray-100 !resize-none leading-[17px] text-sm font-semibold text-black-600 placeholder:text-gray-500"
                @input="(e) => emits('handleInput', e)"
                @keydown.enter.prevent="() => emits('handleSendMessage')"
            />
            <SendButton :isLoading="isLoading" @click="() => emits('handleSendMessage')" />
        </div>

        <div class="flex items-center justify-between !mt-0">
            <div class="flex items-center gap-2 text-gray-400">
                <fa :icon="['fal', 'file-pen']" class="cursor-pointer !text-[20px] !font-[300] !leading-normal" />
                <fa :icon="['fal', 'message-bot']" class="cursor-pointer !text-[20px] !font-[300] !leading-normal" />
                <fa :icon="['fal', 'calendar']" class="cursor-pointer !text-[20px] !font-[300] !leading-normal" />
                <fa :icon="['fal', 'paperclip']" class="cursor-pointer !text-[20px] !font-[300] !leading-normal" />
                <input v-show="false" id="attach_file" type="file" multiple @change="sendFile" />
                <fa :icon="['fal', 'face-smile']" class="cursor-pointer !text-[20px] !font-[300] !leading-normal" />

                <div class="option-icons">
                    <fa :icon="['fal', 'tag']" class="cursor-pointer !text-[20px] !font-[300] !leading-normal" />
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import SendButton from "../../settings/inbox/inbox-component/SendButton.vue";

const emits = defineEmits(["handleSendMessage", "handleInput"]);
const props = defineProps({
    input: {
        type: String,
        default: "",
    },
    isLoading: {
        type: Boolean,
        default: false,
    },
});
</script>
